import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RoleAvatar, UserName } from '../../../../common/components';
import CallButton from '../../../../common/components/Call/CallButton';
import propTypes from '../../../../common/propTypes';
import BEM from '../../../../common/bem';
import PfCallOrigins from '../../../../models/enums/PfCallOrigins';
import { mobxInjectSelect } from 'common/utils';
import { hasAutoForwardConfigured } from 'common/utils/autoForward';

const classes = BEM.with('ConversationHeader');

class RoleConversationHeader extends Component {
  static propTypes = {
    conversation: propTypes.conversation.isRequired,
    isVideoCallEnabled: PropTypes.bool.isRequired,
    isVoiceCallEnabled: PropTypes.bool.isRequired,
    role: propTypes.role.isRequired,
    user: propTypes.user.isRequired,
    currentOrganizationId: PropTypes.string.isRequired,
    isExtendedAutoForwardOptionsEnabled: PropTypes.bool,
  };

  _lastTagStyle = undefined;

  componentDidMount() {
    this.fetchRole();
  }

  componentDidUpdate(prevProps) {
    const { role } = this.props;
    if (prevProps.role.id !== role.id) this.fetchRole();
  }

  fetchRole() {
    const { currentOrganizationId, role, findRole } = this.props;
    findRole(role.id, role.organizationId || currentOrganizationId);
  }

  render() {
    const {
      conversation,
      isVideoCallEnabled,
      isVoiceCallEnabled,
      user,
      role,
      currentOrganizationId,
      isExtendedAutoForwardOptionsEnabled,
    } = this.props;
    const { tag } = role;
    let onDutyStatus, tagFragment;

    // Calculate DND and auto-forward status
    const dnd = user.dnd;
    const showDndAfStatus =
      dnd &&
      isExtendedAutoForwardOptionsEnabled &&
      hasAutoForwardConfigured(user, currentOrganizationId);

    if (role.displayName === user.displayName) {
      onDutyStatus = (
        <span className={classes('user-details')}>
          <span className={classes('no-on-duty')}>No one is on duty</span>
        </span>
      );
    } else {
      onDutyStatus = (
        <span className={classes('user-details')}>
          <span className={classes('on-duty')}>On Duty:</span>
          <span className={classes('basic-details')}>
            <UserName ariaLabel={'Conversation Header Name'} user={user} />
          </span>
          <span className={classes('extra-details')}>
            {user.status && (
              <span aria-label={'Conversation User Status'} className={classes('user-status')}>
                {user.status}
              </span>
            )}
            {user.title && <span className={classes('user-title')}>{user.title}</span>}
          </span>
        </span>
      );
    }

    if (!user.displayName) {
      onDutyStatus = (
        <span className={classes('user-details')}>
          <span className={classes('loader')}>Loading...</span>
        </span>
      );
    }

    if (!tag || tag.isDefault) {
      tagFragment = (
        <div className={classes('role-titles')}>
          <span className={classes('role-name')}>{role.displayName}</span>
        </div>
      );
    } else {
      const { color } = tag;
      if (!this._lastTagStyle || this._lastTagStyle.backgroundColor !== color) {
        this._lastTagStyle = { backgroundColor: color };
      }
      tagFragment = (
        <div className={classes('role-titles')}>
          <span className={classes('role-name')}>{role.displayName}</span>
          <span className={classes('tag-indicator')} style={this._lastTagStyle} />
          <span className={classes('tag-name')}>{tag.displayName}</span>
        </div>
      );
    }

    return (
      <div className={user.status && user.title && classes({ addedMargin: true })}>
        <div className={classes({ role: true })} title={user.displayName}>
          {tagFragment}
        </div>
        <div className={classes({ role: true })} title={user.displayName}>
          <RoleAvatar
            user={user}
            role={role}
            size="fit"
            showPresenceIndicator={true}
            presenceStatus={user.presenceStatus}
            userId={user.id}
            dnd={dnd}
            showDndAfStatus={showDndAfStatus}
          />
          {onDutyStatus}
          {(isVideoCallEnabled || isVoiceCallEnabled) && role.displayName !== user.displayName && (
            <span className={classes('phone-icon', { isRole: true })}>
              <CallButton entity={conversation.counterParty} origin={PfCallOrigins.CONVERSATION} />
            </span>
          )}
        </div>
      </div>
    );
  }
}

export default mobxInjectSelect({
  messengerStore: ['currentOrganizationId', 'isExtendedAutoForwardOptionsEnabled'],
  roleStore: ['findRole'],
})(RoleConversationHeader);
